// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1QQ58","title":"AfterBackImages_title__uMSCp","images":"AfterBackImages_images__1cH_x"};